export var GLOBAL = { 
    //DEV
    //url:'http://192.168.1.66:5000/' //laclicsa
    //url: 'http://192.168.1.68:5000/api/' //c
    //PROD
    url:'http://eserver.laclicsa.com:3000/' //laclicsa
}